export default __webpack_public_path__ + "static/media/dog-small-illustration.80489c7a.svg";